import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface PageHeroProps {
  eyebrow: string;
  title: string;
  description: string;
  breadcrumb: string;
}
export function PageHero({
  eyebrow,
  title,
  description,
  breadcrumb
}: PageHeroProps) {
  return <section className="bg-navy-900" data-id="element-118" data-mp="22z8znhedywg">
      <div className="mx-auto max-w-shell px-6 pb-24 pt-14" data-id="element-119" data-mp="240xatnfchw4">
        <nav aria-label="Breadcrumb" className="text-[14px]" data-id="element-120" data-mp="psjwmjohxkc2">
          <ol className="flex items-center gap-2 text-navy-200" data-id="element-121" data-mp="pvfsm2gs9yxv">
            <li data-id="element-122" data-mp="uqv6uvipdwut">
              <Link to="/" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-123" data-mp="urekw158g13k">
                Home
              </Link>
            </li>
            <ChevronRightIcon className="h-4 w-4 text-white/35" aria-hidden="true" data-id="element-124" data-mp="l1lcta4au442" />
            <li className="text-white" aria-current="page" data-id="element-125" data-mp="18s7hcrf3h69b">
              {breadcrumb}
            </li>
          </ol>
        </nav>

        <p className="mt-11 text-[12px] font-medium tracking-[0.22em] text-gold" data-id="element-126" data-mp="1djfunyjjpbrr">{eyebrow}</p>
        <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-[1.15] text-white sm:text-5xl" data-id="element-127" data-mp="32jdh0i5y7dap">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl text-[17px] leading-relaxed text-navy-200" data-id="element-128" data-mp="2xl2767fnl2sh">{description}</p>
      </div>
    </section>;
}